import { BcfRouterContract } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-router.service';
import { NavigationExtras, Params } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/types';
import {
  provideRouterNavigatorService,
  RouterNavigatorService
} from '@tmf-shared-platform/router/router-navigator.service';
import {
  routerPrepareUrl,
  routerUpdateFragment,
  routerUpdateModalFragmentWithParams
} from '@tmf-shared-platform/router/router-utils';
import { routerUpdateQueryParams } from './router-update-query-params';
import { routerUpdateUrl } from './router-update-url';

export class BcfRouterAdapter implements BcfRouterContract {
  private _routerNavigatorService: RouterNavigatorService = provideRouterNavigatorService();

  // The navigate method navigates to a route.
  public navigate(path: string, extras?: NavigationExtras): void {
    routerUpdateUrl(path, extras?.queryParams, extras?.state, extras?.fragment);
  }

  public goBack(): void {
    this._routerNavigatorService.goBack();
  }

  public updateFragment(fragment: string | undefined, params?: string[]): void {
    if (!fragment) {
      routerUpdateFragment(fragment);
      return;
    }
    if (params) {
      routerUpdateModalFragmentWithParams(fragment, params);
    } else {
      routerUpdateFragment(fragment);
    }
  }

  public updateQueryParams(queryParams: Params, strategy?: 'merge'): void {
    routerUpdateQueryParams(queryParams, strategy);
  }

  // The prepareUrl method prepares a url with the base href and the query params.
  public prepareUrl(path: string, extras?: NavigationExtras): string {
    return routerPrepareUrl(path, extras?.queryParams, extras?.fragment);
  }
}
